export const convertUTC = (value) => {
  if (!value) return "";
  const start = new Date(value);
  const now = new Date();
  let S = ((now - start) / 1000).toFixed(0);
  let differentZone = Math.abs(new Date().getTimezoneOffset());
  let M = (S / 60).toFixed(0) - differentZone;
  let H = Math.floor(M / 60);
  let returnedDays = Math.floor(H / 24);
  let returnedHours = H % 24;
  let returnedMinutes = M % 60;

  let returnedValue = {
    Day: returnedDays,
    Minutes: returnedMinutes,
    Hours: returnedHours,
  };
  return returnedValue;
};
